<template>
  <el-card id="UserRecords">
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="item in comps" :key="item.name" :label="$t(item.label)" :name="item.name">
        <keep-alive>
          <component
              :userNum="$route.query.num"
              :is="item.name"
              :tabCurrent="item.name"
              :current="activeName"
              :auto="false"
              :pageSizes="[5, 10]"
              :backTop="false" />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import FansRecord from "@/components/user/FansRecord";
import FollowRecord from "@/components/user/FollowRecord";
import UserDynamic from "@/components/user/UserDynamic";
import DynComments from "@/components/user/DynComments";
import RecipeComments from "@/components/user/RecipeComments";

export default {
  name: "UserRecords",
  components: {RecipeComments, DynComments, UserDynamic, FollowRecord, FansRecord},
  data() {
    return {
      activeName: null,
      comps: [
        {label: "粉丝记录", name: "FansRecord"},
        {label: "关注记录", name: "FollowRecord"},
        {label: "我的动态", name: "UserDynamic"},
        {label: "动态评论", name: "DynComments"},
        {label: "菜谱评论", name: "RecipeComments"}
      ]
    }
  },
  mounted() {
    // 监听组件是否出现在视口
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        console.log('组件出现在视口');
        this.activeName = "FansRecord";
        this.observer.unobserve(document.getElementById("UserRecords"));
      }
    })

    this.observer.observe(document.getElementById("UserRecords"));
    this.$once('hook:beforeDestroy', () => {
      this.observer.disconnect();
    })
  },
}
</script>

<style scoped>

</style>
